export class HisInformationErrorResult {
  name: string;
}
